import React, { useContext } from 'react';
import styled from 'styled-components';
import { Text } from 'components';

import { StyledServicePhoneContainer } from '../StyledComponents';

import AppointmentDeskContext from '../AppointmentDeskContext';

const AnsweringServicePhone: React.FC = () => {
  const { portalConfig } = useContext(AppointmentDeskContext);

  if (!portalConfig) return null;

  const { answeringServicePhone } = portalConfig;

  return (
    <>
      <StyledServicePhoneContainer
        $justify="center"
        $p={2.4}
        $flexDirection="column"
        $alignItems="center"
      >
        <StyledHeaderText type="secondary">
          Paste this on your listings
        </StyledHeaderText>
        <StyledPhoneNumberText>{answeringServicePhone}</StyledPhoneNumberText>
      </StyledServicePhoneContainer>
    </>
  );
};

const StyledHeaderText = styled(Text)`
  font-size: 16px;
  line-height: 24px;
`;

const StyledPhoneNumberText = styled(Text)`
  font-weight: 600;
  font-size: 38px;
  line-height: 46px;
  margin-top: 12px;
`;

export default AnsweringServicePhone;
